import { hamburgerMenu } from "./modules/hamburgerMenu";
import { inview } from "./modules/inview";
import { mvImages } from "./modules/mvImages";
import { fixedCta } from "./modules/fixedCta";
import { smoothScroll } from "./modules/smoothScroll";

document.addEventListener("DOMContentLoaded", () => {
  hamburgerMenu();
  smoothScroll();
  mvImages();
  fixedCta();
  inview(".inview");
});
